// USD per million tokens, from https://platform.claude.com/docs/en/about-claude/pricing
// (checked 2026-10-12). Global routing, 5-minute cache writes (our default TTL).

type Rate = { input: number; cacheWrite: number; cacheRead: number; output: number }

const RATES: Record<string, Rate | ((promptTokens: number) => Rate)> = {
  'claude-fable-5-1': { input: 10, cacheWrite: 12.5, cacheRead: 0.25, output: 50 },
  'claude-opus-5-5': { input: 4, cacheWrite: 5, cacheRead: 0.2, output: 20 },
  'claude-sonnet-5-5': { input: 2, cacheWrite: 2.5, cacheRead: 0.1, output: 10 },
  // Haiku 5.5 charges more for prompts over 100k tokens.
  'claude-haiku-5-5': (prompt) =>
    prompt > 100_000
      ? { input: 0.5, cacheWrite: 0.625, cacheRead: 0.05, output: 2.5 }
      : { input: 0.1, cacheWrite: 0.125, cacheRead: 0.01, output: 0.5 },
}

export const KNOWN_MODELS = Object.keys(RATES)

/** Cost of one response in micro-dollars (1e-6 USD), or null for an unknown model. */
/** Token counts as the API reports them. */
export type TokenUsage = {
  input_tokens: number
  output_tokens: number
  cache_creation_input_tokens?: number | null
  cache_read_input_tokens?: number | null
}

export function costMicros(model: string, u: TokenUsage): number | null {
  const write = u.cache_creation_input_tokens ?? 0
  const read = u.cache_read_input_tokens ?? 0
  const prompt = u.input_tokens + write + read
  const entry = RATES[model]
  if (!entry) return null
  const r = typeof entry === 'function' ? entry(prompt) : entry
  // per-MTok USD × tokens = micro-USD
  return Math.round(
    r.input * u.input_tokens +
      r.cacheWrite * write +
      r.cacheRead * read +
      r.output * u.output_tokens,
  )
}
